/** Verification / status badge for missing-person cases and updates. */
const STATUS_STYLES = {
  ACTIVE: "bg-[color:var(--rust)] text-[color:var(--bone)]",
  FOUND_SAFE: "bg-[#3d5a3c] text-[color:var(--bone)]",
  LOCATED: "bg-[#3d5a3c] text-[color:var(--bone)]",
  REUNITED: "bg-[#3d5a3c] text-[color:var(--bone)]",
  IDENTIFIED: "bg-[color:var(--sepia)] text-[color:var(--parchment)]",
  DECEASED_VERIFIED: "bg-[color:var(--ink)] text-[color:var(--bone)]",
  CLOSED: "bg-[color:var(--sepia)]/70 text-[color:var(--parchment)]",
  WITHDRAWN: "bg-[color:var(--sepia)]/70 text-[color:var(--parchment)]",
  UNKNOWN: "bg-[color:var(--sepia)]/50 text-[color:var(--parchment)]",
};

const STATUS_TEXT = {
  ACTIVE: "Missing",
  FOUND_SAFE: "Found safe",
  LOCATED: "Located",
  REUNITED: "Reunited",
  IDENTIFIED: "Identified",
  DECEASED_VERIFIED: "Deceased — verified",
  CLOSED: "Closed",
  WITHDRAWN: "Withdrawn",
  UNKNOWN: "Unknown",
};

export default function StatusBadge({ status, testid }) {
  return (
    <span
      data-testid={testid || `status-badge-${(status || "").toLowerCase()}`}
      className={`inline-block px-2 py-0.5 font-heritage-caps text-[10px] tracking-[0.14em] ${STATUS_STYLES[status] || STATUS_STYLES.UNKNOWN}`}
    >
      {STATUS_TEXT[status] || "Unknown"}
    </span>
  );
}

const VERIF_STYLES = {
  UNVERIFIED: "border-[color:var(--rust)]/60 text-[color:var(--rust)]",
  UNDER_REVIEW: "border-[color:var(--sepia)] text-[color:var(--sepia)]",
  VERIFIED: "border-[#3d5a3c] text-[#3d5a3c]",
  OFFICIAL: "border-[color:var(--ink)] text-[color:var(--ink)]",
  DISPROVEN: "border-[color:var(--sepia)]/40 text-[color:var(--ink-soft)] line-through",
};

export function VerificationBadge({ verification }) {
  const labels = {
    UNVERIFIED: "Unverified",
    UNDER_REVIEW: "Under review",
    VERIFIED: "Verified",
    OFFICIAL: "Official update",
    DISPROVEN: "Disproven",
  };
  return (
    <span
      data-testid={`verification-${(verification || "").toLowerCase()}`}
      className={`inline-block border px-1.5 py-px font-heritage-caps text-[9px] tracking-[0.14em] ${VERIF_STYLES[verification] || VERIF_STYLES.UNVERIFIED}`}
    >
      {labels[verification] || "Unverified"}
    </span>
  );
}
